export const getClassCapacityText = (
    capacity: number,
    currentCount: number,
) => {
    if (capacity < 1) return currentCount;
    return `${currentCount}/${capacity}`;
};
